import { render } from "./HeroiconsSolidXCircle.vue?vue&type=template&id=0d66ba3b"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidXCircle.vue"]])

export default __exports__